"use client";

import { createPath } from "@/service/routing/routing";
import { SuperLink as Link } from "@/components/common/super-link";
import { PictureUpload } from "@/components/common/picture-upload/picture-upload";
import { cn } from "@/lib/utils";

export const ClinicalCaseInProgressStatus = ({
  clinicalCase,
  currentStep,
}: {
  clinicalCase: ClinicalCaseVM;
  currentStep: number;
}) => {
  const { category, name, image, steps, verticalImage } = clinicalCase;

  return (
    <div className="sticky top-0 z-100 flex w-full flex-col items-center bg-white py-4">
      <div className="flex w-full items-center justify-between gap-8">
        <header className="flex flex-col gap-2.5">
          {category && (
            <Link
              href={createPath("clinical_case.category", {
                categorySlug: category.slug,
              })}
            >
              <div className="text-remedium-blue text-xs font-medium uppercase hover:underline">
                {category.name}
              </div>
            </Link>
          )}

          <h1 className="text-base font-semibold sm:text-lg">{name}</h1>

          <div className={"flex items-center gap-1"}>
            {Array.from({ length: steps }).map((_, idx) => (
              <div
                className={cn(
                  "h-1 w-3 rounded-full bg-zinc-200",
                  idx <= currentStep && "bg-remedium-blue",
                )}
                key={idx}
              ></div>
            ))}
          </div>
        </header>
        <div className="relative hidden w-1/3 shrink-0 items-center self-stretch sm:flex">
          <PictureUpload
            image={verticalImage || image}
            aspectRatio="1.91 / 1"
            className="h-[115px] rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};
